import { render, staticRenderFns } from "./PriceAndDimencion.vue?vue&type=template&id=d2923a3c&scoped=true&"
import script from "./PriceAndDimencion.vue?vue&type=script&lang=js&"
export * from "./PriceAndDimencion.vue?vue&type=script&lang=js&"
import style0 from "./PriceAndDimencion.vue?vue&type=style&index=0&id=d2923a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2923a3c",
  null
  
)

export default component.exports